const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex">
      {/* Branded side panel */}
      <div className="hidden lg:flex lg:w-1/2 bg-primary text-primary-foreground flex-col justify-between p-12">
        <div>
          <img
            src="/logo-full.png"
            alt="Digital Reporting"
            className="h-10 mb-12 brightness-0 invert"
          />
          <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
            Simplify your iXBRL compliance
          </h2>
          <p className="text-lg opacity-80">
            Convert, tag, and file your financial statements with confidence.
          </p>
        </div>
        <p className="text-sm opacity-60">
          &copy; {new Date().getFullYear()} The Digital Reports Company Limited
        </p>
      </div>

      {/* Form panel */}
      <div className="flex-1 flex items-center justify-center p-6 lg:p-12 bg-background">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
